import { createUseStyles } from "react-jss";
import bannerBg from "assets/images/bannerBg.png";
export const useStyles = createUseStyles({
  billingSection: {
    "& .breadcrumb": {
      borderTop: "1px solid var(--ePrimaryO10)",
      paddingTop: "20px",
    },
    "& .billingDetailsSection": {
      position: "relative",
      "& .ant-row *": {
        fontFamily: `'Brawler', serif !important`,
      },
      marginTop: "50px",
      "& .billingForm": {
        "&>p": {
          marginBottom: "40px",
        },
        "& .exFields": {
          marginBottom: "20px",
          "& .formLabelCommon": {
            fontSize: "14px",
            marginBottom: "5px",
            color: "var(--ePrimary)",
            "& .text-danger": {
              color: "var(--ePrimary)",
              fontWeight: "bold",
            },
          },
          "& input": {
            border: "1px solid var(--ePrimaryO20)",
            color: "var(--ePrimary)",
            "&:focus": {
              border: "1px solid var(--ePrimary)",
            },
          },
        },
        "& .formSmSection": {
          paddingBottom: "20px",
          "& p": {
            marginBottom: "20px",
          },
        },
        "& .checkBox": {
          marginBottom: "50px",
          "& .ant-checkbox .ant-checkbox-inner": {
            backgroundColor: "transparent",
            borderColor: "var(--ePrimary)",
            "&:after": {
              borderColor: "var(--ePrimary)",
            },
          },
        },
      },
      "& .billingSummary": {
        position: "sticky",
        top: "0",
        borderRadius: "10px",
        marginLeft: "20px",
        backgroundColor: "var(--ePrimary)",
        "& .bSumHeader": {
          padding: "20px",
          borderBottom: "1px solid var(--eWhiteO10)",
          "& p": {
            color: "var(--white)",
          },
        },
        "& .bSumBody": {
          "& .bSumProductList": {
            "&:first-child": {
              marginTop: "10px",
            },
            padding: "10px 20px",
            "& .eNmText": {
              color: "var(--white)",
            },
            "& .eMdText": {
              color: "var(--eTernary)",
            },
          },
          "& .bSumTotal": {
            marginTop: "20px",
            padding: "15px 20px",
            backgroundColor: "var(--eWhiteO05)",
            borderTop: "1px solid var(--eWhiteO10)",
            borderBottom: "1px solid var(--eWhiteO10)",
            "& .eMdText": {
              color: "var(--white)",
            },
            "& .eLgText": {
              color: "var(--eTernary)",
            },
          },
          "& .eXSmText": {
            color: "var(--eTernary)",
            padding: "10px 20px",
            letterSpacing: "0.5px",
            lineHeight: "18px",
            fontSize: "10px",
          },
        },
        "& .bSumFooter": {
          marginTop: "20px",
          padding: "20px",
          "& .eBtn": {
            color: "var(--eDark)",
            backgroundColor: "var(--eSecondary)",
            width: "100%",
            "& svg": {
              "& path": {
                fill: "var(--eDark)",
              },
            },
            "&:hover": {
              backgroundColor: "var(--eTernary)!important",
            },
          },
        },
      },
    },
  },
});
